'use client';

import React from 'react';
import { IoPersonSharp } from 'react-icons/io5';

export const HeadshotWrapper = ({
  headshot,
  memberName,
  status,
}: {
  headshot: string;
  memberName: string;
  status: string;
}) => {
  const [showFallbackImage, setShowFallbackImage] = React.useState(false);

  return (
    <div>
      {showFallbackImage ? (
        <div className="flex flex-col">
          <IoPersonSharp size={200} className="company-logo" />
          {status === 'Former Member' && (
            <div className="mt-1 pb-4 text-center text-sm text-gray-700">Status: Former Member</div>
          )}
        </div>
      ) : (
        <img
          alt={`${memberName} headshot`}
          className="company-logo"
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            setShowFallbackImage(true);
          }}
          src={headshot}
        />
      )}
    </div>
  );
};
